
import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogModule } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ProgramModel } from 'src/app/configuration/training/models/exercise.model';
import { TrainingService } from 'src/app/configuration/training/services/training.service';
import { NewEquipmentDialogComponent } from 'src/app/configuration/training/views/new-equipment-dialog/new-equipment-dialog.component';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatLabel, MatHint, MatSuffix, MatFormFieldModule } from '@angular/material/form-field';
import { MatSelect, MatSelectModule } from '@angular/material/select';
import { MatOption, MatOptionModule } from '@angular/material/core';

import { MatInput, MatInputModule } from '@angular/material/input';
import { MatDatepickerInput, MatDatepickerToggle, MatDatepicker, MatDatepickerModule } from '@angular/material/datepicker';
import { MatButton, MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'app-assign-program-dialog',
    templateUrl: './assign-program-dialog.component.html',
    styleUrls: ['./assign-program-dialog.component.css'],
  imports: [MatDialogModule, CdkScrollable, ReactiveFormsModule, MatFormFieldModule, MatLabel, MatSelectModule, MatOptionModule, MatInputModule, MatDatepickerModule, MatButtonModule]
})
export class AssignProgramDialogComponent implements OnInit {

  assignedPgmForm: UntypedFormGroup;
  programs: ProgramModel[];

  constructor(
    private _trainingSrvc: TrainingService,
    public _snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<NewEquipmentDialogComponent>,
    public fb: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any) {

 
 }

  ngOnInit(): void {

    this.assignedPgmForm = this.fb.group({
      ProgramId: '',
      Name: ['',[Validators.required, Validators.maxLength(100)]],
      Description: '',
      Repeat: ['',[Validators.required, Validators.max(30), Validators.min(1)]],
      StartDate: ['', [Validators.required]]
      
    })

    this._trainingSrvc.getActivePrograms().subscribe(result=>{
      this.programs = result as ProgramModel[];
    });

   
  }

  save(){

  }

  onCancel(){
    this.dialogRef.close();
  }

}
